import { Injectable } from '@angular/core';
import {LocalStorage} from "./storage.service";
import {Tenant} from "../models/tenant.model";
import {HttpClient, HttpParams} from "@angular/common/http";
import {ApiResponse} from "../utils/api-util";
import {SearchResult} from "../models/response.model";
import {environment} from "../../../environments/environment";
import {CustomerService} from "./customer.service";

@Injectable({
  providedIn: 'root'
})
export class TenantService {

  API = `${environment.apiUrl}/tenant`;

  /** Current selected tenant */
  @LocalStorage('selected_tenant', Tenant)
  tenant: Tenant;

  /** List of all use tenants */
  @LocalStorage('tenants', Tenant)
  private _allTenants: Tenant[];

  /** Gets tenant list */
  get allTenants(): Tenant[] {
    return this._allTenants;
  }

  /** Sets selected tenant and tenant list */
  set allTenants(tenants: Tenant[]) {
    this.tenant = tenants[0];
    this._allTenants = tenants;
  }

  /**
   */
  constructor(private http: HttpClient,
              private customerService: CustomerService) { }

  /**
   * Calls api to search for tenants based on query
   *
   * @param query
   * @param page
   * @param size
   */
  @ApiResponse(SearchResult, Tenant)
  async search(query: string, page = 0, size = 10): Promise<SearchResult<Tenant>> {
    const params = new HttpParams()
      .set('customerId', `${this.customerService.customer.customerId.toString()}`)
      .set('query', query)
      .set('page', `${page}`)
      .set('size', `${size}`);
    return await this.http.get<SearchResult<Tenant>>(`${this.API}/search`, {params}).toPromise();
  }

  /**
   * Calls api to create new workflow
   *
   * @param name
   */
  @ApiResponse(Tenant)
  async create(name?: string): Promise<Tenant> {
    let body = {
      customerId : this.customerService.customer.customerId.toString(),
      name: name || "New Tenant"
    };
    return await this.http.post<Tenant>(`${this.API}/create`, body).toPromise();
  }

  /**
   * Calls api to update workflow
   *
   * @param tenant
   */
  @ApiResponse(Tenant)
  async update(tenant: Tenant): Promise<Tenant> {
    return await this.http.post<Tenant>(`${this.API}/update`, tenant).toPromise();
  }

  /**
   * Calls api to rename tenant based on tenant id
   *
   * @param tenant
   */
  async rename(tenant: Tenant): Promise<Tenant> {
    const params = new HttpParams()
      .set('tenantId', `${tenant.tenantId}`)
      .set('name', `${tenant.name}`);
    return await this.http.post<Tenant>(`${this.API}/rename`, null, {params}).toPromise();
  }

  /**
   * Calls api to delete tenant based on tenant id
   *
   * @param tenant
   */
  async delete(tenant: Tenant): Promise<Tenant> {
    return await this.http.delete<Tenant>(`${this.API}/delete/${tenant.tenantId}`).toPromise();
  }
}
